import React from 'react'

const Footer = () => {
  return (
    <section  className="bg-blue-500 ">
    <div className="flex justify-center items-center text-xl pt-3 pb-3 font-medium text-black    " >
        Cpoy right by © <span className='text-bold  text-red-600 mx-2 '> Rick Pratihar</span> 2024
    </div>

    </section>
  )
}

export default Footer